import React, { Component } from 'react';
import { FormControl } from 'react-bootstrap';

class InputCell extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: this.props.value || ''
    }
  }

  handleChange(e) {
    this.setState({ value: e.target.value })
  }

  handleBlur(e) {
    this.props.onBlur(e.target && e.target.value || "");
  }

  render() {

    const style = {
      backgroundColor: "#ffffff", //"#fafafa",
      borderColor: "#cccccc",
      borderWidth: "thin",
      borderStyle: "solid",
      overflow: "hidden",
      textAlign: this.props.fieldName === "accountLabel" ? "right" : "left"
    };
    if (this.props.row.column.textAlign !== undefined) {
      style.textAlign = this.props.row.column.textAlign;
    }

    if (this.props.row.width !== undefined) {
      style.width = this.props.row.width - 11;
    }

    return (
      <input
        key={this.props.index}
        value={this.state.value}
        style={style}
        onChange={e => { this.handleChange(e) }}
        onBlur={e => { this.handleBlur(e) }}
        onFocus={e => e.target.select()}
      />
    )
  }

}

export default InputCell;
